import React from "react"
import { Upload, Avatar } from "antd"
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons"
import "./UploadAvatar.scss"
import {
  getPresignedUrl,
  uploadPictureToS3,
  updateImageUrlToBackend,
} from "../../redux/actionCreators/auth"
import { connect } from "react-redux"
import _ from "../../utils/lodashUtils"
import {
  GET_ROBO_IMAGE,
  UPLOAD,
  NOT_AN_IMAGE_ERROR,
  IMAGE_UPLOAD_FAILED,
} from "../../constants/messages"
import { TextTag } from "../../atoms"

class UploadAvatar extends React.Component {
  state = {
    loading: false,
    imageError: "",
  }

  handleChange = async (info) => {
    //get file type
    const isJpgOrPng =
      info.file.type === "image/jpeg" || info.file.type === "image/png"

    if (!isJpgOrPng) {
      this.setState({ imageError: NOT_AN_IMAGE_ERROR })
    } else {
      const fileListLength = info.fileList.length
      const img = info.fileList[fileListLength - 1].originFileObj //get the latest image from the array

      this.setState({ loading: true })

      getPresignedUrl().then((response) => {
        const imageUrl = response.image_url
        this.props
          .uploadPictureToS3(response.pre_signed_url, img)
          .then((response) => {
            if (response === "success") {
              this.props.updateImageUrlToBackend(imageUrl).then(() => {
                this.setState({
                  loading: false,
                  imageError: "",
                })
              })
            } else if (response === "error") {
              this.setState({
                imageError: IMAGE_UPLOAD_FAILED,
                loading: false,
              })
            }
          })
      })
    }
  }

  render() {
    const uploadButton = (
      <div>
        {this.state.loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div className="ant-upload-text">{UPLOAD}</div>
      </div>
    )
    const { imageUrl } = this.state
    const profileImage = _.get(this.props.user, "profile_image")
    const userSavedName = _.get(this.props.user, "display_name")
    return (
      <div>
        <div id="UploadAvatar">
          <Upload
            name="avatar"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            beforeUpload={() => false}
            onChange={this.handleChange}
          >
            {imageUrl ? (
              <Avatar size={100} src={imageUrl} />
            ) : (
              <div>
                {this.state.loading ? (
                  <LoadingOutlined />
                ) : profileImage ? (
                  <Avatar size={100} src={profileImage}>
                    {userSavedName}
                  </Avatar>
                ) : this.props.roboName ? (
                  <Avatar
                    size={100}
                    src={GET_ROBO_IMAGE(this.props.roboName)}
                  />
                ) : userSavedName ? (
                  <Avatar size={100} src={GET_ROBO_IMAGE(userSavedName)} />
                ) : (
                  uploadButton
                )}
              </div>
            )}
          </Upload>
        </div>
        <div>
          {this.state.imageError && (
            <TextTag textType="smallTextPrimary" className="error-text">
              {this.state.imageError}
            </TextTag>
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
})
export default connect(mapStateToProps, {
  getPresignedUrl,
  uploadPictureToS3,
  updateImageUrlToBackend,
})(UploadAvatar)
